import { useUploadStore } from "@components/FileUpload/uploadStore";
import { uploadFileToAzureBlob } from "@services/azureDataApi";
import { SasTokenPrefix, SasTokenPrivilege } from "@services/user/types";
import { getSasToken } from "@services/userApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

export const useShipAgencyTransUploads = (screen: string, fieldName: string) =>
  useMutation({
    mutationFn: ({ files, documentType }: { files: File[]; documentType: string }) =>
      runTransaction(
        {
          module: "vessel_call",
          screen,
          action: "upload_shipping_agency_transfer_document",
          entityType: "shipping_agency_transfer_document",
        },
        async (transactionId) => {
          const store = useUploadStore.getState();
          for (const file of files) {
            if (!store.getFilesForKey(fieldName).includes(file)) continue;

            const { blobUrl, sasToken } = await getSasToken(
              {
                prefix: SasTokenPrefix.VESSEL_CALL,
                contentType: file.type || null,
                privilege: SasTokenPrivilege.WRITE,
                blobUrl: null,
              },
              ...(transactionId ? [transactionId] : []),
            );
            const [result] = await uploadFileToAzureBlob({
              file,
              blobUrl,
              sasToken,
              certificateType: documentType,
            });
            const url = result?.documentUrl ?? blobUrl;
            store.updateFilesForKey(fieldName, (entries) =>
              entries.map((entry) =>
                entry === file ? { name: file.name, type: file.type, url } : entry,
              ),
            );
          }
        },
      ),
  });
